import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/recaudacion/contratos-de-folios-placas/';

/**
 * GET AlmacenesVehiculares
 * @returns {Promise<Array<object>>}
 */
export const getContratosFoliosPlacas = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET ContratoFolioPlaca
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getContratoFolioPlaca = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST ContratoFolioPlaca
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postContratoFolioPlaca = async (values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.post(baseURI, formattedValues);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH ContratoFolioPlaca
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchContratoFolioPlaca = async (id, values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.patch(`${baseURI}${id}`, formattedValues);
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE ContratoFolioPlaca
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteContratoFolioPlaca = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
